"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageGalleryComponent = exports.ImageGalleryComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var swiper_1 = require("swiper");
var index_1 = require("Views/Partials/Components/KeepTheRhythm/index");
var PreviewBox_1 = require("../PreviewBox/PreviewBox");
var webexUI_1 = require("webexUI");
var ImageGalleryComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ImageGalleryComponent, _super);
    function ImageGalleryComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.swiper-slider';
        _this.pageLoad = false;
        _this.activeSlidButton = null;
        _this.onSlideChange = function (currentElement) {
            if (currentElement) {
                var activeSlide = currentElement.find('.swiper-slide-active');
                var activeSlideButton = activeSlide.find('.cta');
                activeSlideButton.attr('tabindex', 0);
                if (_this.activeSlidButton) {
                    _this.activeSlidButton.attr('tabindex', -1);
                }
                _this.activeSlidButton = activeSlideButton;
            }
        };
        return _this;
    }
    ImageGalleryComponent.prototype.OnInit = function () {
        var _this = this;
        this.el.forEach(function (elem) {
            _this.initGallery(elem);
            var externalLink = new app_1.ExternalLink(elem.querySelectorAll('a'));
            externalLink.checkLinks();
        });
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var that = this;
        var onLoad = function () {
            _this.el.forEach(function (el) { return el.classList.add(that.selector.substring(1) + '--inited'); });
        };
        // if ie onload doesn't work
        var timeout = setTimeout(function () {
            if (!_this.pageLoad) {
                _this.pageLoad = true;
                onLoad();
            }
        }, 1000);
        var elWithPlayButton = [];
        this.el.forEach(function (el) {
            return el
                .querySelectorAll('.gallery-top .swiper-slide .slider-video-button')
                .forEach(function (item) { return elWithPlayButton.push(item); });
        });
        elWithPlayButton.forEach(function (item) {
            item.addEventListener('click', function (event) {
                PreviewBox_1.showPreviewBoxWithDataFromImage(event, this, item.hasAttribute('href'));
            });
            item.addEventListener('keypress', function (event) {
                if (event.key === app_1.keyNameMapping.enter || event.key === app_1.keyNameMapping.space) {
                    PreviewBox_1.showPreviewBoxWithDataFromImage(event, this, item.hasAttribute('href'));
                }
            });
        });
        app_1.ComponentService.UpdateComponentsSelector();
        window.addEventListener('load', function () {
            if (!_this.pageLoad) {
                _this.pageLoad = true;
                clearTimeout(timeout);
                onLoad();
            }
        }, true);
    };
    ImageGalleryComponent.prototype.initGallery = function (elem) {
        var _this = this;
        var $elem = $(elem);
        var galleryTopElem = $elem.find('.gallery-top')[0];
        var mouseoverEvent = webexUI_1.createCustomEvent('mouseover');
        var mouseleaveEvent = webexUI_1.createCustomEvent('mouseleave');
        var swiper;
        if ($(galleryTopElem).find('.swiper-slide').length < 2) {
            return;
        }
        var galleryTop = galleryTopElem.swiper;
        if (!galleryTop) {
            try {
                swiper = new swiper_1.default(galleryTopElem, {
                    lazy: true,
                    loop: true,
                    navigation: {
                        nextEl: '.swiper-button-next-webex',
                        prevEl: '.swiper-button-prev-webex',
                    },
                    pagination: {
                        clickable: true,
                        el: '.swiper-pagination',
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    preloadImages: false,
                    runCallbacksOnInit: false,
                    spaceBetween: 20,
                    a11y: {
                        enabled: true,
                    },
                    on: {
                        slideChangeTransitionEnd: function () { return _this.onSlideChange($elem); },
                    },
                    observer: true,
                    observeParents: true,
                });
            }
            catch (e) {
                console.error(e);
            }
            var activeSlideButton = $(this.el).find('.swiper-slide-active .cta');
            activeSlideButton.attr('tabindex', 0);
            this.activeSlidButton = activeSlideButton;
            // MouseOver event handler
            galleryTopElem.dispatchEvent(mouseoverEvent);
            galleryTopElem.dispatchEvent(mouseleaveEvent);
            galleryTopElem.addEventListener('mouseover', function () {
                swiper.autoplay.stop();
            });
            galleryTopElem.addEventListener('mouseleave', function () {
                swiper.autoplay.start();
            });
        }
        index_1.KTR.SetPendingUpdate();
    };
    return ImageGalleryComponent;
}(app_1.Component));
exports.ImageGalleryComponent = ImageGalleryComponent;
exports.imageGalleryComponent = new ImageGalleryComponent();
